import React from 'react';
import { Card, Badge, Alert } from 'react-bootstrap';
import { FileText, Calendar, Mail, Phone } from 'react-feather';

export default function Terms(){
  return (
    <Card className="shadow-lg border-0 rounded-3">
      <Card.Header className="bg-white border-0 pt-4">
        <div className="d-flex align-items-center gap-3 mb-2">
          <div className="bg-primary bg-opacity-10 p-2 rounded">
            <FileText size={24} className="text-primary" />
          </div>
          <div>
            <h2 className="fw-bold text-dark mb-1">Terms & Conditions</h2>
            <div className="d-flex align-items-center gap-2 text-muted small">
              <Calendar size={14} />
              <span>Last updated: 2025-10-09</span>
            </div>
          </div>
        </div>
      </Card.Header>
      
      <Card.Body className="pt-3">
        <Alert variant="info" className="border-0 bg-light-info">
          <small className="fw-medium">
            Please read these terms carefully before using our services.
          </small>
        </Alert>

        <div className="terms-content">
          <ol className="list-unstyled mb-0">
            <li className="mb-4 pb-2 border-bottom">
              <strong className="text-primary d-block mb-1">Eligibility:</strong>
              <span className="text-muted">Delivery partners must be 18+ and legally allowed to work in their jurisdiction.</span>
            </li>
            
            <li className="mb-4 pb-2 border-bottom">
              <strong className="text-primary d-block mb-1">Account Responsibility:</strong>
              <span className="text-muted">Keep your login secure. You are responsible for activity under your account.</span>
            </li>
            
            <li className="mb-4 pb-2 border-bottom">
              <strong className="text-primary d-block mb-1">Compliance:</strong>
              <span className="text-muted">Follow food safety, traffic, and local laws. Tampering with dairy products is strictly prohibited.</span>
            </li>
            
            <li className="mb-4 pb-2 border-bottom">
              <strong className="text-primary d-block mb-1">Service Standard:</strong>
              <span className="text-muted">Deliver within allocated window, maintain product temperature, and be courteous to customers.</span>
            </li>
            
            <li className="mb-4 pb-2 border-bottom">
              <strong className="text-primary d-block mb-1">Payments:</strong>
              <span className="text-muted">Payouts are processed to your registered account as per the agreed cycle, net of applicable deductions and taxes.</span>
            </li>
            
            <li className="mb-4 pb-2 border-bottom">
              <strong className="text-primary d-block mb-1">Equipment:</strong>
              <span className="text-muted">Use insulated bags/boxes approved by Village Milk and keep them clean.</span>
            </li>
            
            <li className="mb-4 pb-2 border-bottom">
              <strong className="text-primary d-block mb-1">Prohibited Conduct:</strong>
              <span className="text-muted">Fraud, misuse, or sharing of customer data is grounds for suspension or termination.</span>
            </li>
            
            <li className="mb-4 pb-2 border-bottom">
              <strong className="text-primary d-block mb-1">App Usage:</strong>
              <span className="text-muted">Don't reverse-engineer, copy, or resell the app. Availability may be interrupted for maintenance.</span>
            </li>
            
            <li className="mb-4 pb-2 border-bottom">
              <strong className="text-primary d-block mb-1">Liability:</strong>
              <span className="text-muted">To the maximum extent permitted by law, VMD Partner is provided "as is" without warranties.</span>
            </li>
            
            <li className="mb-4 pb-2 border-bottom">
              <strong className="text-primary d-block mb-1">Changes:</strong>
              <span className="text-muted">We may update these terms. Continued use constitutes acceptance of the updated terms.</span>
            </li>
            
            <li className="mb-0">
              <strong className="text-primary d-block mb-1">Contact:</strong>
              <div className="d-flex flex-wrap gap-3 mt-2">
                <div className="d-flex align-items-center gap-2 text-muted small">
                  <Mail size={14} />
                  <span>carevillagemilk@gmail.com</span>
                </div>
                <div className="d-flex align-items-center gap-2 text-muted small">
                  <Phone size={14} />
                  <span>8960060092</span>
                </div>
              </div>
            </li>
          </ol>
        </div>
      </Card.Body>
    </Card>
  );
}